import { useMutation } from '@apollo/client';
// Api
import { MARK_NOTIFICATIONS_READ } from 'api/notifications/mutations';
import apolloNotificationClient from 'api/apolloNotificationClient';
// Types
import {
  MarkNotificationsRead,
  MarkNotificationsReadVariables,
} from 'api/notifications/types/MarkNotificationsRead';
// Components
import { showToast } from 'components/common/Toast/Toast';

export const useMarkNotificationRead = () => {
  const [mutate] = useMutation<
    MarkNotificationsRead,
    MarkNotificationsReadVariables
  >(MARK_NOTIFICATIONS_READ, {
    client: apolloNotificationClient,
  });

  const markNotificationRead = async (
    ids: string[] | string
  ): Promise<void> => {
    try {
      await mutate({
        variables: {
          input: {
            ids: Array.isArray(ids) ? ids : [ids],
          },
        },
      });
    } catch (error) {
      showToast({
        message:
          (error as Error).message ||
          'Error updating notification status. Refresh or try again later.',
        type: 'error',
      });
    }
  };

  return { markNotificationRead };
};
